import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
    display: 'flex',
    height: '14px',
    width: '100%',
    maxWidth: '330px',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '288px',
    },
  },
  divider: {
    width: '100%',
    alignSelf: 'center',
    backgroundColor: theme.appColors.lightPurple,
  },
  text: {
    position: 'absolute',
    fontSize: '14px',
    fontWeight: '700',
    textAlign: 'center',
    width: '46px',
    left: 'calc(50% - 23px)',
    color: theme.appColors.primaryColor,
    backgroundColor: theme.appColors.newGreySecondary,
  },
}));
